function customerSection() {
  let plusButton = $('.upload__item--plus');
  let dropzone = $('.dropzone');
  let dropzoneButton = $('.dropzone-save-button');
  plusButton.each(function (i) {
    $(this).on('click', function () {
      $(dropzone[i]).removeClass('is-hidden');
      $(dropzoneButton[i]).removeClass('is-hidden');
    });
  });

  let saveButton = $('.save-serial-number');

  saveButton.each(function () {
    let form = $(this).closest('form');
    let url = form.attr('action');
    let alert = $(this).parent().parent().parent().find('.subject-alert');
    let submitButton = $(this);
    let serialNumber = submitButton.parent().parent().parent();
    alert.addClass('is-hidden');
    $(this).on('click', function (event) {
      event.preventDefault();
      $.ajax({
        type: 'POST',
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          serialNumber.addClass('is-hidden');
          serialNumber
            .parent()
            .find('.overview')
            .find('.subject-serial-number')
            .html(data);
        },
        error: function (data) {
          alert.removeClass('is-hidden');
          alert
            .children()
            .children()
            .find('.alert-message')
            .html(data.responseJSON);
        },
      });
    });
  });
}
